import { axiosInstance } from "./client";
import { camelToKebabCase } from "@rumble-it/common-lib/src/utils/camelToKebabCase";

export const getDossier = async ({ dossierId }: { dossierId: string }) =>
  axiosInstance(`/dossiers/${dossierId}`).then((response) => {
    const dossier = response.data;

    const servicePartner = dossier.servicePartners[0];
    const driver = dossier.driver;

    if (dossier["@type"]) {
      const typeValue = dossier["@type"].replace(/Dossier/g, "");
      dossier.formType = `${camelToKebabCase(typeValue)}`;
    }

    return { dossier, servicePartner, driver };
  });
